var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72005 2.13086H17.0534L17.8867 5.13086H23.8867V21.1309H1.88672V5.13086H7.88672L8.72005 2.13086ZM12.8867 19.1309C16.2004 19.1309 18.8867 16.4446 18.8867 13.1309C18.8867 9.81715 16.2004 7.13086 12.8867 7.13086C9.57301 7.13086 6.88672 9.81715 6.88672 13.1309C6.88672 16.4446 9.57301 19.1309 12.8867 19.1309Z",
    fill: "#010101"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8867,
    cy: 13.1309,
    r: 4,
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3d668feb7e479b26cc27c2c0eecd11ec.svg";
export { ForwardRef as ReactComponent };